import './CodeItem.scss';
import classNames from 'classnames';
import { isArray } from 'lodash';
import React from 'react';
import { SanitizedHtml } from './SanitizedHtml';
import { usePeriscopeActions } from '@hooks';
const GetOnClick = (periscopeOptions) => {
    const { openPeriscope } = usePeriscopeActions();
    if (!periscopeOptions) {
        return undefined;
    }
    return (event) => {
        event.stopPropagation();
        openPeriscope(periscopeOptions);
    };
};
export const CodeItem = ({ className, code, sections }) => {
    var _a, _b;
    if (!code) {
        return null;
    }
    if (isArray(sections)) {
        let i = 0;
        return (React.createElement("code", null,
            React.createElement("div", null,
                sections.map((section) => {
                    const { end, start, periscopeOptions } = section;
                    const iMoreThanStartChar = i > start;
                    if (iMoreThanStartChar) {
                        return null;
                    }
                    const highlight = React.createElement(React.Fragment, { key: `${section.start}-${section.end}` },
                        React.createElement(SanitizedHtml, { as: 'span', html: code.substring(i, start) }),
                        React.createElement(SanitizedHtml, { as: 'span', className: classNames('code-item', 'tag', className, { link: periscopeOptions === null || periscopeOptions === void 0 ? void 0 : periscopeOptions.id }), html: code.substring(start, end), onClick: GetOnClick(periscopeOptions) }));
                    i = end;
                    return highlight;
                }),
                React.createElement(SanitizedHtml, { as: 'span', html: code.substring(i) }))));
    }
    return React.createElement(SanitizedHtml, { as: 'code', className: classNames('code-item', className, {
            link: (_a = sections.periscopeOptions) === null || _a === void 0 ? void 0 : _a.id,
            tag: (_b = sections.periscopeOptions) === null || _b === void 0 ? void 0 : _b.id
        }), html: code, onClick: GetOnClick(sections.periscopeOptions) });
};
